<template>
  <div class="societe-menu">
    <b-dropdown
        class="dropdown-multiple-background-hover-disabled columns is-marginless"
        ref="societeMenu"
        position="is-bottom-left"
        trap-focus
        aria-role="menu">
      <a @click="syncMenu" slot="trigger">
        <div class="columns is-220px-width" v-if="agenceActive.length > 0">
          <div class="column is-4 is-flex is-align-items-center is-justify-content-center">
            <img v-if="logoGeneral" :src="logoGeneral">
            <avatar :username="agenceActive[0].libelleSociete" :size="32" v-else
                    class="mg-auto">
            </avatar>
           </div>
          <div class="column is-6">
            <div>
              <p class="is-size-6 has-text-white ellipsis"> {{ agenceActive[0].libelleSociete }}</p>
              <p class="is-size-9 has-text-white ellipsis"> {{ agenceActive.length > 1 ?
                this.$t('general.multiAgence') : agenceActive[0].libelleAgence }} </p>
            </div>
          </div>
          <div class="column is-2">
            <b-icon icon="chevron-down" class="is-paddingless has-text-white"
                    v-if="isEditable"></b-icon>
            <b-icon icon="lock" size="is-small"
                    class="is-paddingless has-text-white" v-else></b-icon>
          </div>
        </div>
      </a>
      <b-dropdown-item
            aria-role="menu-item"
            :focusable="false"
            custom
            paddingless>
          <div class="cards" v-if="isEditable">
            <div class="pd-2 mgb-40px">
              <qd-button
                class="is-addOrEdit is-pulled-right"
                @click="saveSelection"
                :disabled="!hasOneAgenceSelected"
                :class="[{'disabledButton': !hasOneAgenceSelected}]"
                icon-left="content-save">
                {{ $t('general.button.save') }}
              </qd-button>
            </div>
            <div
              class="card width-300px"
              v-for="(societe, $index) in saveSociete"
              :key="$index">
              <header
                  class="card-header pd-5px"
                  :class="{
                    'has-background-forbidden': !(saveSocieteActive === societe.societeId
                    && hasOneAgenceSelected),
                    'has-background-primary': saveSocieteActive === societe.societeId
                    && hasOneAgenceSelected,
                    'has-text-white': saveSocieteActive === societe.societeId
                    && hasOneAgenceSelected,
                   }">
                <div class="level min-width-100">
                  <div class="level-left">
                    <div class="has-text-left mgl-20px is-paddingless max-width-200">
                      <p class="font-dropdown ellipsis">
                        {{ societe.libelleSociete }}
                      </p>
                    </div>
                  </div>
                  <div class="level-right">
                    <qd-button
                      class="pdh-3 pdv-0"
                      @click="allSocieteSelected(societe)">
                      <b-icon
                        class="pd-0 mgt-1"
                        size="is-small"
                        :icon="societe.agences.every(a => a.selected)
                          ? 'checkbox-multiple-marked-outline'
                          : 'checkbox-multiple-blank-outline'">
                      </b-icon>
                    </qd-button>
                  </div>
                </div>
              </header>
              <div class="card-content is-paddingless">
                <div class="content">
                  <div
                    class="is-cursor-pointer agenceHeaderMenu"
                    :class="{
                      'has-background-select': agence.selected,
                    }"
                    v-for="(agence, $index) in societe.agences"
                    :key="$index">
                    <b-checkbox
                      class="pdl-40px width-100percent"
                      :value="agence.selected"
                      @input="toggleAgence(agence)">
                      <p class="pdl-20px pdt-1 pdb-1 is-default font-dropdown ellipsis">
                        {{ agence.libelleAgence}}
                      </p>
                    </b-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="width-300px">
              <div class="column is-12 is-paddingless">
                <div class="card">
                  <div class="card-content">
                    <div class="pd-1">
                      <qd-message
                      type="is-info"
                      size="is-small"
                      class="mgv-3"
                      >
                        {{ $t('general.impossibleChangementAgenceSociete') }}
                      </qd-message>
                      <p
                      class="has-text-weight-semibold"
                      >
                          {{ $t('general.libelleSociete') }}
                      </p>
                      <p class="has-text-default">
                        {{ societeActive.libelle }}
                      </p>
                      <p class="has-text-weight-semibold">
                        {{ $t('general.libelleAgences') }}</p>
                      <div
                      v-for="(agence, index) in agenceActive"
                        :key="index">
                        <p>
                        {{ agence.libelleAgence }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Avatar from 'vue-avatar';
import getLogo from '@/services/general/getLogo';
import intToGuid from '@/services/general/transformIntToGuid';
import messageErreur from '@/services/general/messageErreur';
import cloneDeep from 'lodash/cloneDeep';

const user = createNamespacedHelpers('user');
const societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'societeMenu',
  data() {
    return {
      logoGeneral: null,
      saveSociete: null,
      saveSocieteActive: null,
    };
  },
  components: {
    Avatar,
  },
  methods: {
    ...societe.mapActions({
      actionSetSocieteId: 'setSocieteId',
      actionSetDetectChangeSociete: 'setDetectChangeSociete',
      setMultipleAgenceActive: 'setMultipleAgenceActive',
    }),
    decocheAllAgence() {
      this.saveSociete.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.selected === true) {
            agence.selected = false;
          }
        });
      });
    },
    syncMenu() {
      this.saveSociete = cloneDeep(this.societeOfUser);
      this.saveSocieteActive = cloneDeep(this.societeActiveId);
      this.decocheAllAgence();
      this.saveSociete.forEach(societe => {
        if (societe.societeId === this.societeActiveId) {
          societe.agences.forEach(agence => {
            if (this.agenceActive.map(a => a.agenceId).includes(agence.agenceId)) {
              agence.selected = true;
            }
          });
        }
      });
    },
    async saveSelection() {
      if (!this.hasOneAgenceSelected) return;
      if (this.saveSocieteActive !== this.societeActiveId) {
        const loadingComponent = this.$buefy.loading.open();
        await this.actionSetSocieteId(this.saveSocieteActive);
        try {
          this.logoGeneral = await getLogo(intToGuid(this.societeActiveId));
        } catch (e) {
          messageErreur(this.$i18n);
          throw e;
        }
        loadingComponent.close();
      }
      const societeUtilisee = this.saveSociete.find(s => s.societeId === this.societeActiveId);
      if (!societeUtilisee) return;
      await this.setMultipleAgenceActive(societeUtilisee.agences.filter(a => a.selected));
      this.$refs.societeMenu.toggle();
      await this.actionSetDetectChangeSociete(!this.detectChangeSociete);
    },
    allSocieteSelected(societe) {
      const allSelected = societe.agences.every(a => a.selected);
      if (societe.societeId !== this.saveSocieteActive) {
        this.decocheAllAgence();
        this.saveSocieteActive = societe.societeId;
      }
      societe.agences.forEach(s => {
        s.selected = !allSelected;
      });
    },
    toggleAgence(agence) {
      agence.selected = !agence.selected;
      if (agence.selected) {
        if (agence.societeId !== this.saveSocieteActive) {
          this.decocheAllAgence();
          this.saveSocieteActive = agence.societeId;
          agence.selected = true;
        }
      }
    },
  },
  computed: {
    isEditable() {
      return ((this.$route.name.indexOf('l.') === 0 || this.$route.name === 'home') && !this.lockMenu) || this.forceUnlockMenu;
    },
    ...permissions.mapGetters({
      userAffixe1: 'userAffixe1',
    }),
    ...user.mapGetters({
      utilisateur: 'user',
    }),
    ...societe.mapGetters({
      agenceActive: 'agenceActive',
      societeActive: 'societeActive',
      societeActiveId: 'societeActiveId',
      societeOfUser: 'societeOfUser',
      detectChangeSociete: 'detectChangeSociete',
      lockMenu: 'lockMenu',
      forceUnlockMenu: 'forceUnlockMenu',
    }),
    hasOneAgenceSelected() {
      return this.saveSociete?.some(societe => {
        return societe.agences.some(a => a.selected);
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.logoGeneral = await getLogo(intToGuid(this.societeActiveId));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
